import { ACTIVATION_STATE, ChecklistVariant } from '../../../components/Activation/types';

/**
 * Activation overview data from the activation_overview view
 */
export interface ActivationOverviewRow {
  user_id: string;
  user_name: string;
  user_email: string;
  fbo_id: string;
  fbo_name: string;
  activation_mode: boolean;
  activation_state: number; // 0=pre, 1=shallow, 2=deep
  autostack_run_count: number;
  deep_activation_threshold: number;
  checklist_progress: number;
  activation_started_at: string | null;
  activation_window_days: number;
  days_since_start: number | null;
  is_stalled: boolean;
  last_activity_at: string | null;
  deep_activation_at: string | null;
  checklist_variant: ChecklistVariant;
  admin_notes: string | null;
}

/**
 * Audit log entry
 */
export interface ActivationAuditLog {
  id: string;
  target_user_id: string;
  fbo_id: string;
  admin_user_id: string;
  action: string;
  old_value: Record<string, unknown> | null;
  new_value: Record<string, unknown> | null;
  reason: string | null;
  created_at: string;
}

/**
 * Admin update payload
 */
export interface ActivationUpdatePayload {
  activation_mode?: boolean;
  activation_started_at?: string | null;
  activation_window_days?: number;
  deep_activation_threshold?: number;
  checklist_variant?: ChecklistVariant;
  admin_notes?: string;
}

/**
 * Filters for the overview table
 */
export type ActivationFilter = 'all' | 'active' | 'stalled' | 'deep';
